import { useState } from "react";
import CommonModal from "./Modal/CommonModal";
import CommonModalTitle from "./Modal/CommonModalTitle";
import TransitInsuranceEnquiryForm from "./ServicesFrom/TransitInsuranceEnquiryForm";

export default function TransitInsuranceService() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };


  return (
    <div>
      <section className="pb-5 pt-0" style={{ backgroundColor: "#fff" }}>
        <div className="services-pages-banner">
          <div>
            <img
              // src="/assets/images/05.webp"
              src="/assets/images/transit-insurance-service.png"
              alt="Not found"
              className="w-100 "
            />
            <img
              src="/assets/images/transit-insurance-service-mobile.webp"
              alt="Not found"
              className="w-100 service-mobile-view-banner"
            />
          </div>
          <div>
            <button
              className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block banner-button"
              onClick={handleOpen}
            >
              <img
                src="/assets/images/arrow_right.svg"
                alt="Not found"
                height={12}
              />
              <span
                className="px-2 d-inline-block fw-bold p-0"
                onClick={handleOpen}
              >
                Request A Quote
              </span>
            </button>
          </div>
        </div>
        <div className="container">
          <section className="courier-mode">
            <div className="row mb-5">
              <div className="col-md-6 ">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/transit-insurance-matters.png"
                    alt="Not found"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>Why International Transit Insurance Matters</h3>
                  <h6 className="mb-3">Because things happen in transit</h6>
                  <p>
                    Whether your cargo is crossing countries or continents, it
                    changes hands multiple times, whether that be through
                    customs, ports, carriers, warehouses, etc. Even the best
                    carriers can face mishaps, accidents, or loss. Insurance
                    safeguards your shipment from accidental damage, loss, or
                    mishandling.
                  </p>

                  <ul>
                    <li>
                      <p>Covers unforeseen damage or loss</p>
                    </li>
                    <li>
                      <p>
                        Applies to all freight modes (air, sea, land, courier)
                      </p>
                    </li>
                    <li>
                      <p>Peace of mind for high-value or fragile items</p>
                    </li>
                  </ul>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>What It Covers</h3>
                  <h6 className="mb-3">
                    From minor dents to partial damage or loss
                  </h6>
                  <p>
                    International transit insurance protects the declared value
                    of your goods from:{" "}
                  </p>

                  <ul>
                    <li>
                      <p>Physical damage due to mishandling or accidents</p>
                    </li>
                    <li>
                      <p>Lost packages during multi-leg freight</p>
                    </li>
                    <li>
                      <p>Accidents or mishaps en route</p>
                    </li>
                  </ul>
                  <p>
                    The coverage depends on the goods' declared value and
                    shipping conditions.
                  </p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/what-it-covers.png"
                    alt="Not found"
                  />
                </div>
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/how-pricing-works.png"
                    alt="Not found"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>How Pricing Works</h3>
                  <h6 className="mb-3">Minimal cost, maximum coverage</h6>
                  <p>
                    Insurance premiums are small but meaningful, calculated
                    based on:
                  </p>

                  <ul>
                    <li>
                      <p>The total declared value of the shipment</p>
                    </li>
                    <li>
                      <p>Shipping method (air, sea, land, courier)</p>
                    </li>
                    <li>
                      <p>Destination and transit risk factors</p>
                    </li>
                  </ul>
                  <p>
                    We always recommend insuring high-value, fragile, or
                    irreplaceable cargo. It’s a low investment that saves you
                    stress and money in the long run.
                  </p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section className="what-to-choose">
            <h3>Disclaimer</h3>
            <p>
              Insurance claims are subject to approval from the insurance
              provider [View Full Policy]. Coverage decisions, claim
              assessments, and payout amounts are determined by the insurer
              based on the terms of your selected policy, the nature of the
              incident, and supporting documentation provided. World2Door
              facilitates the claims process but does not influence the
              insurer’s final decision.
            </p>
            <p>
              We recommend reviewing your policy details carefully and retaining
              all packaging, invoices, and evidence in the event of a claim.
            </p>
          </section>
        </div>
      </section>
     <CommonModal open={open} onClose={handleClose} fullWidth={true}>
        <CommonModalTitle>Transit Insurance Form</CommonModalTitle>
        <TransitInsuranceEnquiryForm handleClose={handleClose}/>
      </CommonModal>
    </div>
  );
}
